import api from "./api";

class UserManager {

    users(config?: any) {
        return api.get(`/users`, config)
    }

    user(id: number | string) {
        return api.get(`/users/${id}`)
    }

    update(id: number | string, data: any) {
        return api.put(`/users/${id}`, data)
    }

    roles(id: number | string) {
        return api.get(`/users/${id}/roles`)
    }

    permissions(id: number | string) {
        return api.get(`/users/${id}/permissions`)
    }

    saveRolePermissions(id: number | string, data: any) {
        return api.put(`/users/${id}/permissions`, data)
    }

    delete(id: number | string) {
        return api.delete(`/users/${id}`)
    }
    restore(id: number | string) {
        return api.put(`/users/${id}/restore`)
    }

    businessUnitCosti(id: number | string) {
        return api.get(`/users/${id}/business_unit_costi`)
    }

    responsabileDi(id: number | string) {
        return api.get(`/users/${id}/responsabile_di`)
    }

    oreLavorative(id: number | string) {
        return api.get(`/users/${id}/ore_lavorative`)
    }

    importaCostiTimesheet(data: any) {
        return api.post(`/users/importa_costi_timesheet`, data)
    }

    retrieveAll(ids: number[]) {
        return api.get(`/users/ids`, { params: { ids } })
    }

    list = this.users
    retrieve = this.user
    paginatedList = this.users
}

const userManager = new UserManager()

export default userManager
